// extracted by mini-css-extract-plugin
export default {"container":"sponsor_container__3I44H","image":"sponsor_image__vui5u","label":"sponsor_label__m6viZ","withImage":"sponsor_withImage__1Pgie","link":"sponsor_link__1487Z"};